import React, {useCallback, useContext, useEffect, useMemo, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {Layout, Modal, notification} from "antd";
import {useTranslation} from "react-i18next";
import {getUserData} from "src/service/auth.service";
import {checkEmpty, getNameProfile,} from "src/service/util.service";
import {AppContext} from "../../context/App.context";
import useFetch, {CachePolicies} from "use-http";
import {UserAPIEndpoint} from "src/service/user.service";
import {HomeContext, HomeProviderContext} from "../../Home/Home.context";

//@ts-ignore
import _ from "lodash";

// import iconHeart from "src/assets/png/Heart.png";
// import iconBookmark from "src/assets/png/Bookmark.png";
// import iconOther from "src/assets/png/Other.png";
// import iconEmail from "src/assets/png/Email.png";
// import iconDelete from "src/assets/png/iconDelete.png";
// import Like1 from "src/assets/png/Like1.png";
// import Like2 from "src/assets/png/Like2.png";
// import Like3 from "src/assets/png/Like3.png";
// import profileSutita from "src/assets/png/profileSutita225.png";
import {pathRoutes} from "../../../props/util.props";
// import Sutita from "src/assets/png/profileSutita.png";
// import postSutita1 from "src/assets/png/postSutita1.png";
// import postSutita2 from "src/assets/png/postSutita2.png";
// import postSutita3 from "src/assets/png/postSutita3.png";
// import profileMieJon from "src/assets/png/profileMieJon.png";
// import profileMikeJo from "src/assets/png/profileMikeJo.png";
// import uploadPhoto from "src/assets/png/uploadPhoto.png";
import FeedCard from "../../../components/Feed/FeedCard";
import FeedsContent from "../../../components/FeedsContent";

const {Header, Footer, Sider, Content} = Layout;

const Post = (props: any) => {
    return (
        <HomeProviderContext>
            <MyPostContainer/>
        </HomeProviderContext>
    );
};

const MyPostContainer = (props: any) => {
    const {t} = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const appCtx: any = useContext(AppContext);
    const homeContext: any = useContext(HomeContext);

    const callLimit = 10;

    // const [isOnePost, setIsOnePost] = useState(false);
    const [showModalCreatePost, setShowModalCreatePost] = useState<boolean>(false);
    const [showLiveModal, setShowLiveModal] = useState<boolean>(false);


    const currPost = homeContext.currentPost;
    let match: any;
    const {confirm, error} = Modal;
    const noDataHeaderText = t("No post available");
    const nodatatext = t("When you share photo and video") + t("they'll appear on your profile");

    const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
        cachePolicy: CachePolicies.NO_CACHE,
    });

    const apiPost = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/feeds/${match?.params?.id}`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const onCloseModalCreatePost = () => {
        setShowModalCreatePost(false);
    }

    const loadPostData = async () => {
        try {
            const res = await apiPost.get();
            console.log("post res", res);

            const postObj = {
                profile: res.user.imageProfileURL,
                userName:
                    res.user.firstname +
                    (_.isEmpty(res.user.lastname) ? "" : " " + res.user.lastname),
                postTime: res.createdAt,
                postCovers: res?.covers,
                title: res?.title,
                postContent: res?.content,
                categories: res?.categories,
                mentions: res?.mentions,
                likes: res?.likeUsers,
                id: res?.id,
                isPin: res?.yourPin,
                userID: res?.user?.username,
                tag: res?.privacy,
            };

            return postObj;
        } catch (error) {
            console.error(error);
        }
    };

    // const checkOnePost = async () => {
    //   if (match !== null) {
    //     setIsOnePost(true);
    //     if (homeContext.currentPost === null) {
    //       const postData = await loadPostData();
    //       homeContext.setCurrentPost(postData);
    //     } else {
    //       if (homeContext.currentPost.id !== match?.params?.id) {
    //         const postData = await loadPostData();
    //         homeContext.setCurrentPost(postData);
    //       }
    //     }
    //   } else {
    //     setIsOnePost(false);
    //   }
    // };

    const setDataUser = async () => {
        if (checkEmpty(homeContext.user)) {
            const me = await api.get(UserAPIEndpoint.Me);
            homeContext.setUser(me);
        }
        if (checkEmpty(appCtx.profile)) {
            appCtx.setProfile({
                usernameProfile: homeContext.user?.id,
                username: homeContext.user?.username,
                nameProfile:
                    getNameProfile(homeContext.user?.firstname, homeContext.user?.lastname),
                imgUrlProfile: homeContext.user?.imageProfileURL,
            });
        }
    };

    useEffect(() => {
        // setDataUser();
    }, []);

    // useEffect(() => {
    //   checkOnePost();
    // }, [location]);

    const sortFeeds = (feeds: any) => {
        feeds?.sort((a: any, b: any) => {
            if (a.createdAt > b.createdAt) return -1;
            if (a.createdAt < b.createdAt) return 1;
        });
    };

    const loadFeeds = async (search: any, limit: any, offset: any) => {
        const data = await api.get(
            `/api/v1/feeds/?search=${search}&limit=${limit}&offset=${offset}&isMyPofile=true`
        );
        sortFeeds(data?.feeds);
        return data;
    };

    const initFeeds = async () => {
        const data = await loadFeeds("", callLimit, 0);
        console.log("Feeds", data?.feeds);
        homeContext.setFeeds(data);
        checkHasMore(data?.feeds?.length, data?.total);
    };

    const setPreviewCovers = (previewCovers: any) => {
        const covers = new Array();
        for (let index = 0; index < previewCovers.length; index++) {
            let cover = {
                coverLink: previewCovers[index],
            };
            covers.push(cover);
        }
        if (_.isEmpty(homeContext.previewCovers)) {
            homeContext.setPreviewCovers(covers);
            showModal();
        } else {
            homeContext.setPreviewCovers((prevCovers: any) => [
                ...prevCovers,
                ...covers,
            ]);
        }
    };

    const setFileCoversData = (fileCovers: any) => {
        if (_.isEmpty(homeContext.fileCovers)) {
            homeContext.setFileCovers(fileCovers);
        } else {
            homeContext.setFileCovers((prevFileCovers: any) => [
                ...prevFileCovers,
                ...fileCovers,
            ]);
        }
    };

    const handleUploadImage = async (event: any) => {
        let previewCovers = new Array();
        let fileCovers = new Array();
        for (let index = 0; index < event.target.files.length; index++) {
            const file = event.target?.files?.[index];
            if (file && file.type.startsWith("image/")) {
                const data = new FormData();
                data.append("file", file);
                data.append("bucket", "post");

                const url = URL.createObjectURL(file);
                previewCovers.push(url);
                fileCovers.push(data);
            } else {
                notification["warning"]({
                    message: t("Upload image error."),
                    description: t("Can not use this image, please select another file."),
                });
            }
        }
        setPreviewCovers(previewCovers);
        setFileCoversData(fileCovers);
    };

    const showModal = () => {
        setShowModalCreatePost(true);
    };

    const checkHasMore = (currentTotal: number, total: number) => {
        if (currentTotal + callLimit >= total) homeContext.setHasMorePost(false);
    };

    const fetchNextPost = async () => {
        console.log("loading more...");

        checkHasMore(homeContext.feeds?.feeds?.length, homeContext.feeds?.total);

        if (homeContext.feeds?.feeds?.length < homeContext.feeds?.total) {
            const comingData = await loadFeeds(
                "",
                callLimit,
                homeContext.feeds?.feeds?.length
            );

            homeContext.setFeeds((prev: any) => {
                const newPostsData = {
                    feeds: [...prev.feeds, ...comingData.feeds],
                    total: prev.total,
                };
                return newPostsData;
            });
        }
    };

    const onLive = async () => {
        navigate(
            pathRoutes.PersonalLive +
            "?id=" +
            homeContext.user?.id +
            "&type=publisher"
        );
        setShowLiveModal(false);
    }

    const handleLive = () => {
        confirm({
            title: t("Do you want to live?"),
            // icon: <ExclamationCircleOutlined />,
            // content: 'Some descriptions',
            onOk() {
                navigate(
                    pathRoutes.PersonalLive +
                    "?id=" +
                    homeContext.user?.id +
                    "&type=publisher"
                );
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const handleBack = () => {
        homeContext.setFeeds(null);
        homeContext.setCurrentPost(null);
        navigate("/profile");
        initFeeds();
    };
    //
    // useEffect((): any => {
    //     let mounted = true;
    //
    //     if (mounted) {
    //         initFeeds();
    //     }
    //
    //     return () => (mounted = false);
    // }, [homeContext.user]);


    const renderFeed = useCallback((feed: any) => {
        return (
            <FeedCard
                key={feed.id}
                id={feed.id}
                avatarURL={feed.user?.imageProfileURL}
                name={
                    feed.user?.firstname +
                    (_.isEmpty(feed.user?.lastname)
                        ? ""
                        : " " + feed.user?.lastname)
                }
                createdAt={feed.createdAt}
                title={feed.title}
                ownerId={feed?.user?.id}
                owner={feed?.user?.username}
                content={feed.content}
                covers={feed?.covers}
                likes={feed.likeUsers}
                isLike={feed?.likeUsers?.some((item: any) => item.usserID === getUserData().id)}
                isPin={feed?.yourPin}
                canUsePin={true}
                isPinType={true}
                isMyPaperPin={feed?.myPaperPin}
                contentStyle={feed?.styleContent}
                onOpenComments={(feedId: string) => {
                    // setCurrentFeedId(feedId)
                    // setOpenComments(true)
                }}
                totalComments={feed?.commentSummary ? feed?.commentSummary : 0}
                privacy={feed?.privacy}
                mentions={feed?.mentions}
                categories={feed.categories}
                onEditPost={(post: any) => {
                    homeContext.setTitle(post.title);
                    homeContext.setContent(post.content);
                    homeContext.setPrivacyOption(post.privacyOption);
                    homeContext.setOldData(post.oldData);
                    homeContext.setOldcover(post.oldCover);
                    homeContext.setCaptionStyle(post.captionStyle);

                    homeContext.setPreviewCovers(post.previewCovers);
                    homeContext.setTag(post.tag);
                    homeContext.setCategory(post.categories);

                    homeContext.setIsEditPost(true);
                    homeContext.setPostID(post.feedId);
                    setShowModalCreatePost(true);
                }}
                onDelete={(feedId: string) => {
                    // let newFeed = feeds.filter((of: any) => {
                    //   return of.id !== feedId
                    // })
                    // setFeeds(newFeed);
                }}
                onOpenOwnerProfile={(userId: string) => {
                    // setCurrentProfileId(userId);
                    // setShowProfileModal(true);
                }}
            />
        )
    }, [])

    // const renderFeeds = useMemo(() => {
    //     if (!homeContext.feeds) return []
    //     return (homeContext.feeds.feeds.map((feed: any) => {
    //         return renderFeed(feed)
    //     }))
    // }, [homeContext.feeds])

    return (
        // <Layout
        //     id="HomeContainer"
        //     className={styles.HomeContainer}
        //     style={{
        //         width: "auto",
        //         minHeight: "calc(100vh - 50px)",
        //         overflow: "auto",
        //     }}
        // >
        //     <Content>
                <FeedsContent
                    style={{
                        width: "auto",
                        height: "calc(100vh - 50px)",
                        overflow: "auto",
                    }}
                    params={{isMyProfile: true}}
                />
            // </Content>
        // </Layout>
    );
    // return (
    //   <Layout>
    //     <CenterContent>
    //       <Row style={{ fontSize: "20px", backgroundColor: "#F8F8F8" }}>
    //         <div style={{ overflow: "hidden" }}>
    //           <img
    //             src={coverSutita}
    //             style={{ width: "100%", position: "relative" }}
    //           ></img>
    //         </div>
    //         <div
    //           className={styles.boxWriteSomething}
    //           style={{ height: 158, marginTop: 30 }}
    //         >
    //           <div
    //             style={{
    //               paddingLeft: 19,
    //               paddingTop: 27,
    //               fontSize: 20,
    //               color: "#BEBEBE",
    //             }}
    //           >
    //             Write something...
    //           </div>
    //         </div>
    //         <div
    //           className={styles.boxPost}
    //           style={{ marginTop: 30, marginBottom: 30 }}
    //         >
    //           <div
    //             style={{
    //               padding: 22,
    //               paddingTop: 46,
    //               paddingBottom: 53,
    //               display: "inline-flex",
    //             }}
    //           >
    //             <div
    //               className={styles.personalImg}
    //               style={{
    //                 backgroundImage: `url(${imgUrlProfile})`,
    //                 width: 85,
    //                 height: 85,
    //               }}
    //             ></div>
    //             <div style={{ alignSelf: "center", paddingLeft: 21 }}>
    //               <div style={{ fontSize: 23, fontWeight: 600 }}>
    //                 {nameProfile}
    //               </div>
    //               <div style={{ paddingTop: 8, fontSize: 17, opacity: 0.55 }}>
    //                 1 April 2020 15:15 PM
    //               </div>
    //             </div>
    //           </div>
    //           <div style={{ overflow: "hidden" }}>
    //             <img src={postSutita1} style={{ width: "100%" }}></img>
    //           </div>
    //           <div style={{ padding: 26, paddingLeft: 22, paddingRight: 28 }}>
    //             <img src={iconHeart}></img>
    //             <img src={iconBookmark} className={styles.iconBookmark}></img>
    //             <img src={iconOther} className={styles.iconOther}></img>
    //             <img src={iconEmail} className={styles.iconEmail}></img>
    //           </div>
    //           <div style={{ paddingLeft: 19, display: "inline-flex" }}>
    //             <img src={Like1} style={{ width: 40, height: 39 }}></img>
    //             <img src={Like2} style={{ width: 40, height: 39 }}></img>
    //             <img src={Like3} style={{ width: 40, height: 39 }}></img>
    //             <div style={{ paddingLeft: 9, fontSize: 22, fontWeight: 600 }}>
    //               {t("Like by")} Jay {t("and")} 200 {t("others")}
    //             </div>
    //           </div>
    //           <div
    //             style={{
    //               padding: "26px 10px 6px 22px",
    //               fontSize: 18,
    //               color: "#000000",
    //             }}
    //           >
    //             Type your current and design the new one. Then the system will
    //             allow you to log-in with the new you design after you logged-out
    //           </div>
    //           <div style={{ paddingLeft: 22, color: "#BEBEBE" }}>
    //             {t("View all 2 comments")}
    //           </div>
    //           <div style={{ paddingLeft: 22, paddingTop: 16, paddingRight: 36 }}>
    //             <div style={{ display: "inline-flex" }}>
    //               <div>
    //                 <img src={profileMieJon}></img>
    //               </div>
    //               <div style={{ paddingLeft: 31 }}>
    //                 <div style={{ fontSize: 20, fontWeight: 600 }}>Mie Jon</div>
    //                 <div style={{ fontSize: 18, paddingTop: 16 }}>
    //                   Type your current and design the new one. Then the system
    //                   will allow you to log-in with the new you design after you
    //                   logged-out
    //                 </div>
    //                 <div style={{ fontSize: 14, color: "#B1B0B0" }}>
    //                   07/04/2020 | 18:00 PM
    //                 </div>
    //               </div>
    //               <div style={{ alignSelf: "center" }}>
    //                 <img src={iconDelete} style={{ paddingLeft: 53 }}></img>
    //               </div>
    //             </div>
    //             <div style={{ display: "inline-flex", paddingTop: 14 }}>
    //               <div>
    //                 <img src={profileMikeJo}></img>
    //               </div>
    //               <div style={{ paddingLeft: 31 }}>
    //                 <div style={{ fontSize: 20, fontWeight: 600 }}>Mike Jo</div>
    //                 <div style={{ fontSize: 18, paddingTop: 16 }}>
    //                   Type your current and design the new one. Then the system
    //                   will allow you to log-in with the new you design after you
    //                   logged-out
    //                 </div>
    //                 <div style={{ fontSize: 14, color: "#B1B0B0" }}>
    //                   07/04/2020 | 18:00 PM
    //                 </div>
    //               </div>
    //               <div style={{ alignSelf: "center" }}>
    //                 <img src={iconDelete} style={{ paddingLeft: 53 }}></img>
    //               </div>
    //             </div>
    //           </div>
    //           <div
    //             style={{
    //               paddingLeft: 22,
    //               paddingRight: 34,
    //               paddingTop: 31,
    //               paddingBottom: 44,
    //             }}
    //           >
    //             <Input
    //               placeholder="Add Comment"
    //               suffix="Post"
    //               style={{ border: "none" }}
    //             ></Input>
    //           </div>
    //         </div>
    //         <div
    //           className={styles.boxPost}
    //           style={{ marginTop: 30, marginBottom: 30 }}
    //         >
    //           <div
    //             style={{
    //               padding: 22,
    //               paddingTop: 46,
    //               paddingBottom: 53,
    //               display: "inline-flex",
    //             }}
    //           >
    //             <div
    //               className={styles.personalImg}
    //               style={{
    //                 backgroundImage: `url(${imgUrlProfile})`,
    //                 width: 85,
    //                 height: 85,
    //               }}
    //             ></div>
    //             <div style={{ alignSelf: "center", paddingLeft: 21 }}>
    //               <div style={{ fontSize: 23, fontWeight: 600 }}>
    //                 {nameProfile}
    //               </div>
    //               <div style={{ paddingTop: 8, fontSize: 17, opacity: 0.55 }}>
    //                 1 April 2020 15:15 PM
    //               </div>
    //             </div>
    //           </div>
    //           <div style={{ overflow: "hidden" }}>
    //             <img src={postSutita2} style={{ width: "100%" }}></img>
    //           </div>
    //           <div style={{ padding: 26, paddingLeft: 22, paddingRight: 28 }}>
    //             <img src={iconHeart}></img>
    //             <img src={iconBookmark} className={styles.iconBookmark}></img>
    //             <img src={iconOther} className={styles.iconOther}></img>
    //             <img src={iconEmail} className={styles.iconEmail}></img>
    //           </div>
    //           <div style={{ paddingLeft: 19, display: "inline-flex" }}>
    //             <img src={Like1} style={{ width: 40, height: 39 }}></img>
    //             <img src={Like2} style={{ width: 40, height: 39 }}></img>
    //             <img src={Like3} style={{ width: 40, height: 39 }}></img>
    //             <div style={{ paddingLeft: 9, fontSize: 22, fontWeight: 600 }}>
    //               {t("Like by")} Jay {t("and")} 200 {t("others")}
    //             </div>
    //           </div>
    //           <div
    //             style={{
    //               padding: "26px 10px 6px 22px",
    //               fontSize: 18,
    //               color: "#000000",
    //             }}
    //           >
    //             Type your current and design the new one. Then the system will
    //             allow you to log-in with the new you design after you logged-out
    //           </div>
    //           <div
    //             style={{ paddingLeft: 22, color: "#BEBEBE", paddingBottom: 36 }}
    //           >
    //             {t("View all 2 comments")}
    //           </div>
    //         </div>
    //         <div
    //           className={styles.boxPost}
    //           style={{ marginTop: 30, marginBottom: 30 }}
    //         >
    //           <div
    //             style={{
    //               padding: 22,
    //               paddingTop: 46,
    //               paddingBottom: 53,
    //               display: "inline-flex",
    //             }}
    //           >
    //             <div
    //               className={styles.personalImg}
    //               style={{
    //                 backgroundImage: `url(${imgUrlProfile})`,
    //                 width: 85,
    //                 height: 85,
    //               }}
    //             ></div>
    //             <div style={{ alignSelf: "center", paddingLeft: 21 }}>
    //               <div style={{ fontSize: 23, fontWeight: 600 }}>
    //                 {nameProfile}
    //               </div>
    //               <div style={{ paddingTop: 8, fontSize: 17, opacity: 0.55 }}>
    //                 1 April 2020 15:15 PM
    //               </div>
    //             </div>
    //           </div>
    //           <div style={{ overflow: "hidden" }}>
    //             <img src={postSutita3} style={{ width: "100%" }}></img>
    //           </div>
    //           <div style={{ padding: 26, paddingLeft: 22, paddingRight: 28 }}>
    //             <img src={iconHeart}></img>
    //             <img src={iconBookmark} className={styles.iconBookmark}></img>
    //             <img src={iconOther} className={styles.iconOther}></img>
    //             <img src={iconEmail} className={styles.iconEmail}></img>
    //           </div>
    //           <div style={{ paddingLeft: 19, display: "inline-flex" }}>
    //             <img src={Like1} style={{ width: 40, height: 39 }}></img>
    //             <img src={Like2} style={{ width: 40, height: 39 }}></img>
    //             <img src={Like3} style={{ width: 40, height: 39 }}></img>
    //             <div style={{ paddingLeft: 9, fontSize: 22, fontWeight: 600 }}>
    //               {t("Like by")} Jay {t("and")} 200 {t("others")}
    //             </div>
    //           </div>
    //           <div
    //             style={{
    //               padding: "26px 10px 6px 22px",
    //               fontSize: 18,
    //               color: "#000000",
    //             }}
    //           >
    //             Type your current and design the new one. Then the system will
    //             allow you to log-in with the new you design after you logged-out
    //           </div>
    //           <div
    //             style={{ paddingLeft: 22, color: "#BEBEBE", paddingBottom: 36 }}
    //           >
    //             {t("View all 2 comments")}
    //           </div>
    //         </div>
    //       </Row>
    //     </CenterContent>
    //   </Layout>
    // );
};

export default Post;
